var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyNameIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 3.42873C1.33301 2.27157 2.27108 1.3335 3.42825 1.3335H9.52348C10.6807 1.3335 11.6187 2.27157 11.6187 3.42873V4.38111H12.5711C13.7283 4.38111 14.6663 5.31918 14.6663 6.47635V12.5716C14.6663 13.7288 13.7283 14.6668 12.5711 14.6668H6.47586C5.3187 14.6668 4.38063 13.7288 4.38063 12.5716V11.6192H3.42825C2.27108 11.6192 1.33301 10.6811 1.33301 9.52397V3.42873ZM5.52348 12.5716C5.52348 13.0976 5.94988 13.524 6.47586 13.524H12.5711C13.0971 13.524 13.5235 13.0976 13.5235 12.5716V6.47635C13.5235 5.95037 13.0971 5.52397 12.5711 5.52397H6.47586C5.94988 5.52397 5.52348 5.95037 5.52348 6.47635V12.5716ZM10.4759 4.38111H6.47586C5.3187 4.38111 4.38063 5.31918 4.38063 6.47635V10.4764H3.42825C2.90226 10.4764 2.47586 10.05 2.47586 9.52397V3.42873C2.47586 2.90275 2.90226 2.47635 3.42825 2.47635H9.52348C10.0495 2.47635 10.4759 2.90275 10.4759 3.42873V4.38111Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyNameIcon);
export default __webpack_public_path__ + "static/media/copy-name-icon.4bef537084f991d4d1cbd2d91a86fbf1.svg";
export { ForwardRef as ReactComponent };